import Modal from "components/layout/modal";
import { FunctionComponent } from "react";
import EntityForm from "./entity-form";
import { ListEntity } from "models/list-entity";
import { FormValues, fromFromValues } from "lib/form";
import { useList } from "stores/hooks/list";
import { useListUser } from "stores/hooks/list-user";
import { adminDoPostEntityCollection } from "services/admin/list-user-entity-collection";
import { EntityCollectionValue } from "models/list-user-entity-collection-value";

interface AddEntityModalProps {
  listEntity: ListEntity;
  onUpdate: () => Promise<void>;
  onClose: () => Promise<void>;
}

const AddEntityModal: FunctionComponent<AddEntityModalProps> = ({
  listEntity,
  onClose,
  onUpdate,
}) => {
  const list = useList();
  const listUser = useListUser();

  const handleSubmit = async (formValues: FormValues) => {
    if (!list || !listUser) {
      return;
    }

    // take secret flag away
    const secret = formValues.secret as any;
    delete formValues.secret;

    // since the values has uuid-answer pairs, make into EntityFieldValue array
    const entityCollection = {
      secret,
      entityCollectionValues: fromFromValues(
        [],
        formValues,
      ) as EntityCollectionValue[],
    };

    // create entity collection
    await adminDoPostEntityCollection(
      list.uuid,
      listUser.uuid,
      listEntity.uuid,
      entityCollection,
    );

    // update and close
    onUpdate();
    onClose();
  };

  return (
    <Modal title="Lisää uusi">
      <EntityForm
        listEntity={listEntity}
        listEntityFields={listEntity.listEntityFields || []}
        onClose={onClose}
        onSubmit={handleSubmit}
      />
    </Modal>
  );
};

export default AddEntityModal;
